import centimetersToMeters from "src/app/helpers/centimeters-to-meters";
import { toExcelFormat } from "src/app/helpers/format-position";
import { getEventTypeName, getTaskTypeName } from "src/app/helpers/format-task-type";
import { CrateListPallet, CrateListPalletState, EventType, IEventHistory, ISellOrderEventHistory } from "src/models/History";
import * as moment from 'moment/moment';
    
export function toEventHistoryItem(data:IEventHistory):any{
    return {
      height: data?.groundPositionGroupLevelName?.length > 0 ? data.groundPositionGroupLevelName : (data.z >= 0 ? centimetersToMeters(data.z) + ' metros' : 'Conflitante'),
      taskType: getTaskTypeName(data.taskType, data.type),
      movedAt: data.timestamp ? moment(data.timestamp).format('DD/MM/YYYY HH:mm:ss.SSS') : '---',
      position: data.groundPositionAlias ? data.groundPositionAlias : `--- (coordenada: ${toExcelFormat(data.x, data.y)})`,
      user: !data.user ? '---' : data.user.firstName + ' ' + data.user.lastName,
      deviceName: data.deviceName || '---',
      eventName: getEventTypeName(data.type),
      type: data.type,
      enableExpansion: data.type === EventType.EDIT_PRODUCT || data.type === EventType.EDITED_UNLOAD || data.type === EventType.TRANSFER_IN || data.type === EventType.TRANSFER_OUT,
      previousSkuGroups: data.previousSkuGroups ?? [],
      currentSkuGroups: data.currentSkuGroups ?? [],
      id: data.id,
    }
  }

export function toSellOrderEventHistoryItem(data) {
  const { checkedPallets, missingPallets } = getOrderHistoryPalletsByState(data);

  return {
    taskType: getTaskTypeName(data.taskType, data.type),
    user: !data.user ? '---' : data.user.firstName + ' ' + data.user.lastName,
    deviceName: data.deviceName || '---',
    eventName: getEventTypeName(data.type),
    type: data.type,
    enableExpansion: data.type === EventType.FINISH,
    id: data.id,
    movedAt: data.timestamp ? moment(data.timestamp).format('DD/MM/YYYY HH:mm:ss.SSS') : '---',
    checkedPallets,
    missingPallets
  }
}

function getOrderHistoryPalletsByState(data: ISellOrderEventHistory) {
  const pallets = data?.crateList?.pallets ?? [];

  return pallets.reduce((acc, pallet) => {
    const mappedPallets = mapOrderHistoryPallet(pallet);

    if (pallet.state === CrateListPalletState.MISSING) {
      acc.missingPallets.push(...mappedPallets);
      return acc;
    }

    acc.checkedPallets.push(...mappedPallets);
    return acc;
  }, {
    checkedPallets: [],
    missingPallets: []
  });
}

function mapOrderHistoryPallet(pallet: CrateListPallet): { id: string; sku: string }[] {
  if (!pallet.skuGroups?.length) {
    return [{
      id: pallet.tagRfid || pallet.crateId,
      sku: '---'
    }];
  }

  return pallet.skuGroups.map(skuGroup => ({
    id: pallet.tagRfid || pallet.crateId,
    sku: skuGroup.sku || '---'
  }));
}
